<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p style="text-align: center;">For Mila: wife, mother, grandmother.</p><br/>
<p style="text-align: center;">You are greatly missed.</p><br/><br/><br/>
<p style="text-align: center;">And for our daughter, Rika, and</p><br/>
<p style="text-align: center;">grandchildren, Sabina and Michael</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?4e028538